// extracted by mini-css-extract-plugin
module.exports = {"main-component":"bulletPoint_main-component__3rrzr"};